import styled, { css } from "styled-components";
import FlexBox from "../../../FlexBox/FlexBox";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";

export const _InnovationProductRoot = styled(FlexBox)<{}>(
  () => {
    return {
      "&.mosaique": {
        cursor: "pointer",
        height: "100%",
      },
      ".innovation-product": {
        "&.text-on-desktop": {
          display: "none",
          [`@media ${responsiveMap.mobile}`]: {
            display: "block",
          },
        },
      },
      ".innovation-product-action-button": {
        marginTop: 24 - 8,
        [`@media ${responsiveMap.mobile}`]: {
          width: "100%",
        },
        "&.text-on-desktop": {
          [`@media ${responsiveMap.mobile}`]: {
            width: "unset",
          },
        },
      },
    };
  },
  css`
    .innovation-product.action-on-hover {
      position: relative;
      /* Garde l’overlay visible au survol du CTA (évite la disparition en passant de la vidéo au bouton) */
      &:hover .action-on-hover--overlay,
      .action-on-hover--overlay:has(.innovation-product-action-button:hover),
      .action-on-hover--overlay:has(
          .innovation-product-action-button:focus-visible
        ) {
        opacity: 1;
      }
    }

    .action-on-hover--overlay {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%;
      height: 100%;
      z-index: 1;
      background: rgba(0, 0, 0, 0.6);

      padding: 0 10px 29px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      opacity: 0;
      pointer-events: none;

      transition: opacity 0.3s ease-out;

      .innovation-product-action-button {
        pointer-events: auto;
      }
    }

    .innovation-product.chef-2024 .action-on-hover--overlay {
      background: transparent;
    }
  `
);
